/**
 * Inicializacion condicional de Sentry para el frontend.
 *
 * Si VITE_SENTRY_DSN esta configurado, se habilita captura de errores en runtime.
 * Si no, las funciones son no-ops para no romper nada.
 */
import * as Sentry from '@sentry/react'
import { sanitizeSentryEvent } from '../../../shared/sentryPrivacy.js'

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN
const ENABLED = Boolean(SENTRY_DSN)

export function initSentry() {
  if (!ENABLED) return false

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENV || import.meta.env.MODE,
    release: import.meta.env.VITE_APP_VERSION || undefined,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    sendDefaultPii: false,
    beforeSend: sanitizeSentryEvent,
  })
  return true
}

export function captureException(err, context = {}) {
  if (!ENABLED) return
  Sentry.captureException(err, { extra: context })
}

export const isSentryEnabled = () => ENABLED
export { Sentry }
